import { useQuery } from "@tanstack/react-query";

import { getContactsOptions } from "../../generated/client/octalog-service/@tanstack/react-query.gen";

export function useGetContactsQuery() {
  return useQuery({
    ...getContactsOptions(),
  });
}
